import { createEvent } from 'effector';

import { NewRequestState } from './NewRequestState';

export const newRequestEvent = createEvent<Partial<NewRequestState>>('newRequestEvent');
